/*
 * @Author: bbqin
 * @Date: 2023-01-04 10:30:42
 * @LastEditTime: 2023-02-02 10:47:25
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\api\cryptograph\symmetric.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import AES from './adapter/common';
import SM from './adapter/sm';

/**
 * 加密解密器
 */
class Symmetric {
    constructor(props) {
        // common sm
        this.algorithmName = props.algorithmName || 'common';

        // 算法
        this.algorithm = this.getAlgorithm(props.config);
    }

    // 检查组件是否完成初始化，主要针对国密场景
    check(callback) {
        this.algorithm?.check(callback);
    }

    /**
     * 静态密钥，用于处理某些全局无法通信的加密
     * @returns {string}
     */
    getStaticSecretKey() {
        let secretKey = '';
        switch (this.algorithmName) {
            case 'common':
                secretKey = '4fa8959db7b4423a99f056e299914128';
                break;
            case 'sm':
                secretKey = '{"keyIndex":"-1","secretKey":"bWvHbB879nbOCrmOQvES7A=="}';
                break;
            default:
                secretKey = '4fa8959db7b4423a99f056e299914128';
                break;
        }
        return secretKey;
    }

    /**
     * 获取当前的算法
     * @param {object} config 
     * @returns  {object | null}
     */
    getAlgorithm(config = {}) {
        let algorithm = null;
        // TODO  根据算法类型  获得对应算法方案
        switch (this.algorithmName) {
            case 'common':
                algorithm = new AES(config);
                break;
            case 'sm':
                algorithm = new SM(config);
                break;
            default:
                algorithm = new AES(config);
                break;
        }
        // 应该不存在  不生成密钥的方式
        return algorithm;
    }

    /**
     * 对称加密
     * @param {string} message 
     * @param {string} key 
     * @returns  {string}
     */
    symmetricEncrypt(message = '', key) {

        return this.algorithm?.symmetricEncrypt(message, key);
    }

    /**
     * 对称解密
     * @param {string} message 
     * @param {string} key 
     * @returns  {string}
     */
    symmetricDecrypt(message = '', key) {

        return this.algorithm?.symmetricDecrypt(message, key);
    }

    /**
     * 生成密钥
     * @returns {string}
     */
    generateSecretKey() {
        return this.algorithm?.generateKey();
    }

    /**
     * 获取存储的密钥
     * @returns {string}
     */
    getSecretKey() {
        return this.algorithm?.getSecretKey();
    }

    // 加签
    sign(salt, data) {
        return this.algorithm?.sign(salt, data);
    }
}

export default Symmetric;